<script lang="ts">
    
    import { roomsService } from "../../Services";
    import Picture from "../Shared/Picture.svelte";
    import Watch from "../Watch.svelte";

    export let roomId: string;

    const room = roomsService.getRoom(roomId);

</script>

<div class="room-bar">
    {#await room}
        Cargando...
    {:then room}
        <div class="room">
            <div class="picture">
                <Picture id={room.pictureId} />
            </div>
            <div class="state">
                <div class="name"><Watch state={room.name} /></div>
            </div>
        </div>
    {/await}
    {#if $$slots.default}
        <div class="sloted">
            <slot />
        </div>
    {/if}
</div>

<style lang="scss">

    $picture-size: 4.5rem;

    .room-bar {
        height: 104px;
        width: 100%;
        box-sizing: border-box;
        display: flex;
        gap: 1rem;
        padding: 1rem;
        background-color: #fff;
        color: #000;
    }

    .room {
        flex: 1 1 0;
        display: flex;
        align-items: center;
        gap: 0.5rem;
    }

    .sloted {
        flex: 1 1 0;
        display: flex;
        justify-content: flex-end;
    }

    .picture {
        width: $picture-size;
        height: $picture-size;
    }

    .state {
        flex: 1 1 0;
    }

    .name {
        font-size: 1.6rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

</style>

